var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { frontEndApi } from '../common/utils';
import { dispatchGtmEvent } from '../common/gtm';
export function initSearchFunc(args) {
    var lastSearch = args.input.value;
    var wait = false;
    var onBeforeRefresh = [];
    var onAfterRefresh = [];
    args.input.addEventListener('keyup', function () { return refresh(); });
    function refresh(force) {
        var _a;
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var value, resp, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        value = args.input.value.trim();
                        if (!force && (wait || lastSearch === value)) {
                            return [2 /*return*/];
                        }
                        onBeforeRefresh.forEach(function (cb) { return cb(); });
                        wait = true;
                        lastSearch = value;
                        args.resultsContainer.classList.add('is--searching');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, frontEndApi.post('Common@search', {
                                search: value,
                            })];
                    case 2:
                        resp = _b.sent();
                        args.resultsContainer.innerHTML = (_a = resp.payload) === null || _a === void 0 ? void 0 : _a.html;
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        args.resultsContainer.innerHTML = "<p>An error occurred</p>";
                        return [3 /*break*/, 4];
                    case 4:
                        wait = false;
                        if (!(lastSearch !== args.input.value.trim())) return [3 /*break*/, 6];
                        return [4 /*yield*/, refresh()];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        args.resultsContainer.classList.remove('is--searching');
                        onAfterRefresh.forEach(function (cb) { return cb(); });
                        dispatchGtmEvent('AC.interaction.search.complete', {
                            query: lastSearch,
                        });
                        _b.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    return {
        refresh: refresh,
        onBeforeRefresh: function (cb) {
            typeof cb === 'function' && (onBeforeRefresh.push(cb));
        },
        onAfterRefresh: function (cb) {
            typeof cb === 'function' && (onAfterRefresh.push(cb));
        },
        clear: function () {
            args.input.value = '';
            [].slice.apply(args.resultsContainer.childNodes).forEach(function (n) { return args.resultsContainer.removeChild(n); });
        },
    };
}
export function initStdSearch() {
    var root = document.querySelector('.siteSearch');
    if (!root) {
        return;
    }
    var controls = root.querySelector('.siteSearch-controls'), input = controls.querySelector('input'), button = controls.querySelector('button'), resultsContainer = root.querySelector('.siteSearch-results');
    input.focus();
    var searcher = initSearchFunc({ input: input, resultsContainer: resultsContainer });
    button.addEventListener('click', function () { return searcher.refresh(true); });
    searcher.onAfterRefresh(function () {
        var newHref = location.href.replace(/([?&]s=)([^&])*/, '$1' + encodeURIComponent(input.value.trim()));
        window.history.pushState('', '', newHref);
    });
}
